// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UAQzp8U1MkbcciHw60i_ {
    display: flex;
    padding: 8px 0;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/process-removals/components/step-removals.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".applicant {\n    display: flex;\n    padding: 8px 0;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"applicant": `UAQzp8U1MkbcciHw60i_`
};
export default ___CSS_LOADER_EXPORT___;
